module.exports = __webpack_public_path__ + "img/cross.2b686044.png";